import React, { ReactNode } from 'react';
import { IPlanOverviewDetail } from '@models/interfaces/user.interface';
import { CDN_URL } from '@utils/constants/url.constants';

export interface IPlanContentItem {
  main: ReactNode;
  secondary: ReactNode;
  imageUrl: string;
}

export function getPlanContent(planDetail: IPlanOverviewDetail) {
  const period = planDetail.billing_period.toLowerCase();
  const timePeriod =
    period === 'year' || planDetail.billing_frequency == 1
      ? period
      : planDetail.billing_frequency + ' ' + period + 's';

  const items: IPlanContentItem[] = [];
  items.push({
    main: (
      <>
        {planDetail.worksheet_credit}{' '}
        <span className={'font-bold'}>GenieSmart</span> worksheets per{' '}
        {timePeriod}
      </>
    ),
    secondary: 'Personalised by patented AI systems',
    imageUrl: CDN_URL + 'assets/images/subscription/geniesmart.svg',
  });
  if (planDetail.is_allow_gc) {
    items.push({
      main: (
        <>
          Unlimited access to <span className={'font-bold'}>GenieClass</span>{' '}
          for {planDetail.billing_frequency}{' '}
          {planDetail.billing_period.toLowerCase() +
            (planDetail.billing_frequency != 1 ? 's' : '')}
        </>
      ),
      secondary: 'Over 100+ live classes available weekly',
      imageUrl: CDN_URL + 'assets/images/subscription/genieclass.svg',
    });
  }
  if (planDetail.is_allow_ga) {
    items.push({
      main: (
        <>
          Daily access to <span className={'font-bold'}>GenieAsk</span> groups
        </>
      ),
      secondary: 'Get academic help from dedicated teachers',
      imageUrl: CDN_URL + 'assets/images/subscription/genieask.svg',
    });
  }
  items.push({
    main: (
      <>
        <span className={'font-bold'}>Bubble Store</span> learning rewards
        system
      </>
    ),
    secondary: 'Choose from 5,000 redeemable items',
    imageUrl: CDN_URL + 'assets/images/subscription/bubblestore.svg',
  });

  return items;
}
